document.addEventListener("DOMContentLoaded", (event) => {  

    class Node {
        constructor(data){
            this.data = data;
            this.next = null;
            this.prev = null;
        }

        toggle(){
            this.data.classList.toggle('active-brand');
        }

    }

    class DoublyLinkedList {
        constructor(n) {
            this.cicle = n
            this.currentRight = null;
            this.currentLeft = null;
            this.head = null; // Primer nodo de la lista
            this.tail = null; // Último nodo de la lista
            this.size = 0;    // Tamaño de la lista
        }

        // Agregar al final de la lista
        append(data) {
            const newNode = new Node(data);
            if (!this.head) {
                this.head = newNode;
                this.tail = newNode;
                this.currentLeft = newNode;
            } else {
                this.tail.next = newNode;
                newNode.prev = this.tail;
                this.tail = newNode;
                if (this.size+1 == this.cicle) {
                    this.currentRight = newNode;
                }
            }
            this.size++;
        }

        // Agregar al inicio de la lista
        prepend(data) {
            const newNode = new Node(data);
            if (!this.head) {
                this.head = newNode;
                this.tail = newNode;
            } else {
                newNode.next = this.head;
                this.head.prev = newNode;
                this.head = newNode;
            }
            this.size++;
        }

        // Eliminar un nodo por su valor
        delete(data) {
            if (!this.head) return null;

            let current = this.head;
            while (current) {
                if (current.data === data) {
                    if (current === this.head) {
                        this.head = current.next;
                        if (this.head) this.head.prev = null;
                    } else if (current === this.tail) {
                        this.tail = current.prev;
                        if (this.tail) this.tail.next = null;
                    } else {
                        current.prev.next = current.next;
                        current.next.prev = current.prev;
                    }
                    this.size--;
                    return current.data;
                }
                current = current.next;
            }
            return null;
        }

        // Imprimir la lista hacia adelante
        printForward() {
            let current = this.head;
            let result = [];
            while (current) {
                result.push(current.data);
                current = current.next;
            }
            console.log(result.join(" <-> "));
        }

        // Imprimir la lista hacia atrás
        printBackward() {
            let current = this.tail;
            let result = [];
            while (current) {
                result.push(current.data);
                current = current.prev;
            }
            console.log(result.join(" <-> "));
        }

        // Obtener el tamaño de la lista
        getSize() {
            return this.size;
        }

        // Verificar si la lista está vacía
        isEmpty() {
            return this.size === 0;
        }


        updateCurrent(type) {
            if (!this.currentLeft || !this.currentRight) return; // Verificar nodos actuales
        
            console.log("Current Left: ", this.currentLeft.data);
            console.log("Current Right: ", this.currentRight.data);
        
            if (type === "right") {
                // Desactiva el nodo actual izquierdo
                this.currentLeft.toggle();
        
                // Mueve el puntero al siguiente nodo a la derecha (manejo circular)
                this.currentLeft = this.currentLeft.next ? this.currentLeft.next : this.head;
        
                // Desactiva el nodo actual derecho
                this.currentRight.toggle();
        
                // Mueve el puntero al siguiente nodo a la derecha (manejo circular)
                this.currentRight = this.currentRight.next ? this.currentRight.next : this.head;
        
                // Activa el nuevo nodo derecho
                this.currentRight.toggle();
            }
        
            if (type === "left") {
                // Desactiva el nodo actual derecho
                this.currentRight.toggle();
        
                // Mueve el puntero al nodo anterior a la izquierda (manejo circular)
                this.currentRight = this.currentRight.prev ? this.currentRight.prev : this.tail;
        
                // Desactiva el nodo actual izquierdo
                this.currentLeft.toggle();
        
                // Mueve el puntero al nodo anterior a la izquierda (manejo circular)
                this.currentLeft = this.currentLeft.prev ? this.currentLeft.prev : this.tail;
        
                // Activa el nuevo nodo izquierdo
                this.currentLeft.toggle();
            }
        }
        
        

    }
    

    const slides = document.getElementsByClassName("brand-item");
    dll = new DoublyLinkedList(5);
    Array.from(slides).forEach((slide) => {
        dll.append(slide);
    });


    const leftArrow = document.querySelector(".prev");
    const rightArrow = document.querySelector(".next");

    leftArrow.addEventListener("click", () => {
        dll.updateCurrent("left");
    });

    rightArrow.addEventListener("click", () => {
        dll.updateCurrent("right");
    });



});

